export default "__VITE_ASSET__Rlh5bbSY__"